import { render, staticRenderFns } from "./HarbourVisitsTable.vue?vue&type=template&id=61e504c2"
import script from "./HarbourVisitsTable.vue?vue&type=script&lang=ts"
export * from "./HarbourVisitsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports